<template>
  <div class="animated fadeIn">
    <div class="row">
      <div class="col-sm-12 vh-header d-flex flex-column pr-0">
        <div class="card flex-1-auto h-100 overflow-auto">
          <div class="card-header card-header-with-button">
              <h5>{{$t('USERS')}}</h5>
              <button type="button" class="btn-bis btn-primary" @click="showModal()">{{$t('NEW')}}</button>
          </div>
            <div class="card-body" v-if="data.root == null || !data.root.length">
              <p class="center">{{$t('NODATAFOUND')}}</p>
            </div>
            <div class="table-responsive h-100 flex-1-auto" v-if="data.root != null && data.root.length">
              <table class="table table-bis">
                <thead>
                  <tr>
                        <th>{{$t('ID')}}</th>
                        <th>{{$t('USERNAME')}}</th>
                        <th>{{$t('USEREMAIL')}}</th>
                        <th>{{$t('NAME')}}</th>
                        <th>{{$t('SURNAME')}}</th>
                        <th>{{$t('USERGROUP')}}</th>
                        <th v-if="(globals && globals.acl.UserSubCompanies && globals.acl.UserSubCompanies.insertAction)">{{$t('USERSUBCOMPANIES')}}</th>
                        <th v-if="(globals && globals.acl.UserCompanies && globals.acl.UserCompanies.insertAction)">{{$t('USERCOMPANIES')}}</th>
                        <th>{{$t('ACTION')}}</th>
                    </tr>
                </thead>
                <tbody>
                  <template v-for="item in data.root">
                    <tr :key="item.userId">
                        <td>{{item.userId}}</td>
                        <td>{{item.username}}</td>
                        <td>{{item.userEmail}}</td>
                        <td>{{item.name}}</td>
                        <td>{{item.surname}}</td>
                        <td>{{item.groupName}}</td>
                        <td v-if="(globals && globals.acl.UserSubCompanies && globals.acl.UserSubCompanies.insertAction)">{{ (item.subCompanyName == 'Unspecified') ? '-' : item.subCompanyName}}</td>
                        <td v-if="(globals && globals.acl.UserCompanies && globals.acl.UserCompanies.insertAction)">{{(item.companyName == 'Unspecified') ? '-' : item.companyName}}</td>
                        <td class="table-buttons">
                            <b-button type="reset" class="btn-table table-btn-tertiary" v-on:click.prevent="showModal(item)">{{$t('EDIT')}}</b-button>
                            <b-button type="reset" class="btn-table table-btn-delete ml-2" v-on:click.prevent="deleteRow(item.userId)">{{$t('DELETE')}}</b-button>
                        </td>
                    </tr>
                  </template>
                </tbody>
              </table>
            </div>
            <pagination
                v-bind:totalCount="data.totalCount"
                v-model="pagination">
            </pagination>
          </div>
        </div>
    </div>
    <usersform v-model="formData" v-on:close="formData = null; getData()"></usersform>
  </div>
</template>

<script>

import { mapGetters } from 'vuex';
import Api from '@/api/admin/Users';
import UsersForm from './UsersForm.vue';

export default {
    name: 'Users',
    components:
    {
        usersform: UsersForm,
    },
    data()
    {
        const me = this;

        return {
            loading: true,
            data: {},
            formError: {},
            formData: null,
            pagination: {
                query: '',
                currentPage: 1,
                limit: 25,
            },
            searchTimeout: false,
        };
    },
    created()
    {
        const me = this;
        me.getData();
    },
    methods:
  {
      
      async getData()
      {
          const me = this;
        try
        {
            const data = await Api.selectRow(me.getParams);

            if (data.error && data.error === true)
            {
                throw (data);
            }

            for(var i=0;i<data.root.length;i++)
            {
              data.root[i].password = '';
              data.root[i].trhidden = false;
            }

            me.data = data;
        }
        catch (error)
        {
            me.$notify.notice(error);
        }
      },
      async deleteRow(id)
      {
          const me = this;
            me.$store.commit('setModalAlert',
                {
                    text: me.$i18n.t('AREYOUSHURE'),
                    async btnAction()
                    {
                        const data = await Api.deleteRow(
                            {
                                id,
                            },
                        );

                        me.$notify.notice(data);
                        me.getData();
                    },
                });
      },
      showModal(item)
      {
          const me = this;
          if (item == null)
          {
              item = {};
          }
          me.formData = { ...item };
      },
  },
    watch:
    {
        pagination:
        {
            deep: true,
            handler()
            {
                const me = this;

                if (me.searchTimeout !== false)
                {
                    clearTimeout(me.searchTimeout);
                }

                me.searchTimeout = setTimeout(() =>
                {
                    me.getData();
                    me.searchTimeout = false;
                }, 300);
            },
        },
    },
    computed:
  {
      ...mapGetters([
          'globals',
      ]),
      getParams()
      {
          const me = this;
          const data = { ...me.pagination };
          data.start = (data.currentPage - 1) * data.limit;
          return data;
      },
  },
};
</script>
